"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return import(
  /* webpackChunkName: "page-load-modal-launcher" */
  'crm_ui/onboarding/PageLoadModalLauncher').then(function (mod) {
    return mod.default;
  });
};

exports.default = _default;
module.exports = exports.default;